import React from 'react';
import PropTypes from 'prop-types';
import noop from '../../../util/noop';

const Radio = ({
  label = '',
  name = '',
  value = '',
  options = [],
  error = '',
  touched = false,
  onChange = noop,
  onBlur = noop,
  ...props
}) => (
  <label className={`input-radio ${error && touched ? 'error' : ''}`}>
    <p className='input-label type-p'>{label}</p>
    {error && <p className='input-error'>{error}</p>}
    <ul className='options'>
      {options.map(({ label: optionLabel, value: optionValue }) => (
        <li className='option' key={optionValue}>
          <label>
            <input
              type='radio'
              name={name}
              value={optionValue}
              checked={value === optionValue}
              onChange={onChange}
              onBlur={onBlur}
            />
            <p className='option-label type-caption color-grey1'>
              {optionLabel}
            </p>
          </label>
        </li>
      ))}
    </ul>
  </label>
);

Radio.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    })
  ),
};

export default Radio;
